'use client';

import { freddyTheme, IconButton } from '@coolblue-development/freddy';
import selectOptionTrigger from '@coolblue-development/ga4-events/triggers/InternalIcons/selectOptionTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ReactElement, ReactNode } from 'react';

export default function PrixcillaIconButton({
  iconLabel,
  url,
  index,
  totalIndices,
  children
}: {
  iconLabel: string;
  url: string;
  index: number;
  totalIndices: number;
  children: ReactNode;
}): ReactElement {
  const { trackEvent } = useAnalytics();

  return (
    <IconButton
      aria-label={iconLabel}
      component='a'
      href={url}
      size='small'
      target='_blank'
      onClick={() => {
        trackEvent(
          selectOptionTrigger({
            sub_feature: 'prixcilla',
            index: index,
            total_indices: totalIndices,
            selection_type: 'selected',
            option_name: 'prixcilla',
            attribute: 'prixcilla'
          })
        );
      }}
      sx={{
        padding: '0.6rem',
        svg: {
          width: freddyTheme.spacing[500],
          height: freddyTheme.spacing[500]
        }
      }}
    >
      {children}
    </IconButton>
  );
}
